 
 
$(document).ready(function(){
    $(".shopify-section-group-header-group").removeClass("shopify-section");
    $(".shopify-section-group-footer-group").removeClass("shopify-section");
        $(".shopify-section-group-footer-group").appendTo(".about-section9-container-box");
        

let header_height=$(".header-section").outerHeight(true);
$(".main-slideshow").css("padding-top",`${header_height}px`);

            initPcFullpage();
     
  
})
 
function initPcFullpage() {
 //初始化 PC 端的 fullpage
    var playExecuted1 = false;
    var playExecuted2 = false;
    var playExecuted3 = false;
    var numberExecuted1 = false;
    var numberExecuted2 = false;
    var fullpagePC = new fullpage('#main-content', {
     
        licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
        scrolling:true,
        
        navigation: false,
        scrollHorizontally: true,
        navigationPosition: 'right',
      
        loopHorizontal: false,
        sectionSelector: '.shopify-section',
        scrollingSpeed:800,
        onLeave: function(origin, destination, direction) {
            var origin = this;
console.log(origin,"origin");
         
       
              

                //page6
                if (direction === 'down' && origin.index === 4) {
                    $('.page6 .text').addClass('active')
                }
                if (direction === 'up' && origin.index === 5) {
                    $('.page6 .text').removeClass('active')
                }

                //page7
                if (direction === 'down' && origin.index === 5) {
                    $('.about-section7-container .section-content').addClass('active')
                }
                if (direction === 'up' && origin.index === 6) { 
                    $('.about-section7-container .section-content').removeClass('active')
                }
           
        }, 
        afterLoad: function(origin, destination, direction) {
                        var origin = this;
                   
                      
                        if (direction === 'down' && origin.index === 0) {
                            console.log(origin,"origin");
                                            if(!playExecuted1){
                                                $('#about-section2-video')[0].play();
                                                $('#about-section2-video-mb')[0].play();
                                                playExecuted1 = true;
                                            }
                                            // if(!numberExecuted1) {
                                            //     $('.page2-1 .gd-count').countUp();
                                            //     numberExecuted1 = true;
                                            // }
                                        }   
                                        if (direction === 'down' && origin.index === 1) {
                                            console.log(origin,"origin");
                                            if(!numberExecuted2) {
                                                $('.about-section3-container .gd-count').countUp({
                                                    delay: 1,
                                                    time: 100
                                                });;
                                                numberExecuted2 = true;
                                            }
                                            if(!playExecuted2){
                                                $('#about-section3-video')[0].play();
                                                $('#about-section3-video-mb')[0].play();
                                                playExecuted2 = true;
                                            }
                                        } 
                                        $('#about-section4-video')[0].play();
                                        $('#about-section6-video')[0].play();  
                                        $('#about-section6-video-mb')[0].play();                  
                    
                    },
        beforeLeave: function(origin, destination, direction) {

        },

})
}

// function initMobileFullpage() {
//     var playExecuted4 = false;
//     var playExecuted5 = false;
//     var playExecuted6 = false;
//     var numberExecuted3 = false;
//     var numberExecuted4 = false;
//     var isVideoPlaying = false;
//     new fullpage('#main-content', {
//         //options here
//         autoScrolling: true,
//         navigation: false,
//         scrollHorizontally: true,
//         responsiveHeight: true,
//         navigationPosition: 'right',
//         licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
//         easingcss3: 'cubic-bezier(.825,0,.5,1)',
//         parallax: true,
//         parallaxOptions: {
//             type: 'reveal',
//             percentage: 100,
//             property: 'translate'
//         },
//         showCredits: false,
//         // 自定义选择器
//         sectionSelector: '.shopify-section',
//         onLeave: function(origin, destination, direction) {
//             var origin = this;


//             //page6
//             if (direction === 'down' && origin.index === 4) {
//                 $('.page6 .text').addClass('active')
//             }
//             if (direction === 'up' && origin.index === 5) {
//                 $('.page6 .text').removeClass('active')
//             }

//             //page7
//             if (direction === 'down' && origin.index === 5) {
//                 $('.page7 .text').addClass('active')
//             }
//             if (direction === 'up' && origin.index === 6) {
//                 $('.page7 .text').removeClass('active')
//             }

//         },
//         afterLoad: function(origin, destination, direction) {
//             var origin = this;
//             $('.page').removeClass('invisible');

//             if (direction === 'down' && origin.index === 0) {

//                 if(!playExecuted4){
//                     $('#video4')[0].play()
//                     playExecuted4 = true;
//                 }
//                 if(!numberExecuted3) {
//                     $('.page2-1 .gd-count').countUp();
//                     numberExecuted3 = true;
//                 }
//             }
//             if (direction === 'down' && origin.index === 1) {
//                 if(!numberExecuted4) {
//                     $('.page2-2 .gd-count').countUp();
//                     numberExecuted4 = true;
//                 }
//                 if(!playExecuted5){
//                     $('#video5')[0].play()
//                     playExecuted3 = true;
//                 }
//             }
//             if (direction === 'down' && origin.index === 2) {

//                 if(!playExecuted6){
//                     $('#video6')[0].play()
//                     playExecuted3 = true;
//                 }
//                 if(!numberExecuted3) {
//                     $('.page2-1 .gd-count').countUp();
//                     numberExecuted4 = true;
//                 }
//             }
//             $('#video8')[0].play()

//         },

//     });
// }


// if($(window).width() > 750) {
//     // 初始化 PC 端的 fullpage
//     var playExecuted1 = false;
//     var playExecuted2 = false;
//     var playExecuted3 = false;
//     var numberExecuted1 = false;
//     var numberExecuted2 = false;
//     var fullpagePC = new fullpage('#main-content', {
//         //options here
//         autoScrolling: true,
//         navigation: false,
//         scrollHorizontally: true,
//         navigationPosition: 'right',
//         licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
//         // easingcss3: 'cubic-bezier(.825,0,.5,1)',
//         // parallax: true,
//         /*parallaxOptions: {
//             type: 'reveal',
//             percentage: 100,
//             property: 'translate'
//         },*/
//         scrollingSpeed: 800,
//         showCredits: false,
//         // 自定义选择器
//         sectionSelector: '.shopify-section',

//         onLeave: function(origin, destination, direction) {
//             var origin = this;
// console.log(origin,"origin");
//             //page5
//             /*if (direction === 'down' && origin.index === 4) {
//                 $('.page5 .text').addClass('active')
//             }
//             if (direction === 'up' && origin.index === 5) {
//                 $('.page5 .text').removeClass('active')
//             }*/

//             //page6
//             if (direction === 'down' && origin.index === 4) {
//                 $('.page6 .text').addClass('active')
//             }
//             if (direction === 'up' && origin.index === 5) {
//                 $('.page6 .text').removeClass('active')
//             }

//             //page7
//             if (direction === 'down' && origin.index === 5) {
//                 $('.page7 .text').addClass('active')
//             }
//             if (direction === 'up' && origin.index === 6) {
//                 $('.page7 .text').removeClass('active')
//             }
//             if (direction === 'up' && origin.index === 7) {
//                 // fullpage_api.setAllowScrolling(false, 'up');
//                 // fullpage_api.setKeyboardScrolling(false, 'up');
//             }



//         },
//         afterLoad: function(origin, destination, direction) {
//             var origin = this;
       
//             console.log(origin,"origin");
//             if (direction === 'down' && origin.index === 0) {

//                 if(!playExecuted1){
//                     $('#about-section2-video')[0].play()
//                     playExecuted1 = true;
//                 }
//                 if(!numberExecuted1) {
                   
//                     numberExecuted1 = true;
//                 }
//             }
//             // if (direction === 'down' && origin.index === 1) {
//             //     if(!numberExecuted2) {
//             //         $('.page2-2 .gd-count').countUp();
//             //         numberExecuted2 = true;
//             //     }
//             //     if(!playExecuted2){
//             //         $('#video2')[0].play()
//             //         playExecuted2 = true;
//             //     }
//             // }
//             // if (direction === 'down' && origin.index === 2) {
//             //     if(!numberExecuted1) {
//             //         $('.page2-1 .gd-count').countUp();
//             //         numberExecuted1 = true;
//             //     }
//             // }
           
//         },
//         beforeLeave: function(origin, destination, direction) {

//         },

//     })
// }
// else {
//     // 初始化 移动端的 fullpage
//     initMobileFullpage()
// }

// $(window).resize(function(){
//     if($(window).width() < 750 ) {
//         fullpagePC.destroy()
//         location.reload();
//         initMobileFullpage()
//     }
//     else {
//         location.reload();
//     }
// })


